import { Box, Button, InputAdornment, styled, Typography, CircularProgress, Grid, IconButton } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import TextFormField from '@components/FormFields/TextFormField/TextFormField.component';
import { Form } from 'react-final-form';
import EyeIcon from 'icons/Eye.icon';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { toast } from 'react-toastify';

export const Route = createFileRoute(
  '/(dashboard)/_dashboard/profile/password'
)({
  component: RouteComponent,
});

const inputFields = [
  {
    name: 'currentPassword',
    label: 'Current Password',
    type: 'password',
  },
  {
    name: 'newPassword',
    label: 'New Password',
    type: 'password',
  },
];

const StyledContainer = styled(Box)(() => ({
  // padding: '32px',
}));

function RouteComponent() {

  const [currentPassword, setCurrentPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(false);


  const changePasswordMutation = useMutation({
    mutationFn: async (values: { currentPassword: string; newPassword: string }) => {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        'https://interviewer.runasp.net/api/users/edit-password',
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },

    onSuccess: (data) => {
      toast.success('Password changed successfully!');
      setCurrentPassword(false);
      setNewPassword(false)
    }
  });

  const handleSubmit = (values: any) => {
    changePasswordMutation.mutate({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    });
  };

  return (
    <StyledContainer>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              // marginTop: '48px',
              gap: '48px',
              flex: 1,
            }}
          >

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px'}}>
                <TextFormField
                  required
                  name="currentPassword"
                  label="Current Password"
                  variant="outlined"
                  type={currentPassword ? 'text' : 'password'}
                  fullWidth
                  slotProps={{
                  input: {
                    endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setCurrentPassword((prev) => !prev)}
                        edge="end"
                      >
                        {currentPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  }
                }}
                />
                <TextFormField
                  required
                  name="newPassword"
                  label="New Password"
                  variant="outlined"
                  type={newPassword ? 'text' : 'password'}
                  fullWidth
                  slotProps={{
                  input: {
                    endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setNewPassword((prev) => !prev)}
                        edge="end"
                      >
                        {newPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  }
                }}
                />
                {changePasswordMutation.error && (
                  <Typography color="error" variant="body2">
                    {changePasswordMutation.error.response?.data?.title || 'Something went wrong'}
                  </Typography>
                )}

            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: '16px',
                alignSelf: { xs: 'stretch', sm: 'flex-end' },
                flexDirection: { xs: 'column', sm: 'row' },
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              <Button 
                type="submit" 
                variant="contained"
                disabled={changePasswordMutation.isPending}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  order: { xs: 1, sm: 2 },
                }}
              >
                {changePasswordMutation.isPending ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Save Changes'
                )}
              </Button>
              <Button
                type="reset"
                variant="outlined"
                sx={{
                  border: '1px solid #FFFFFF1A',
                  background: 'var(--Light-Gray)',
                  color: 'var(--Interviewer-Black)',
                  width: { xs: '100%', sm: 'auto' },
                  order: { xs: 2, sm: 1 },
                }}
                disabled={changePasswordMutation.isPending}
              >
                Cancel
              </Button>
            </Box>
          </form>
        )}
      />
    </StyledContainer>
  );
}
